import type { HierarchyRectangularNode } from '@visx/hierarchy/lib/types.js';

import type { InternalTreeMapNode } from '../types/internal.js';

export const getClusterPosition = (
  entry: HierarchyRectangularNode<InternalTreeMapNode>,
): { x0: number; x1: number; y0: number; y1: number } => ({
  x0: entry.x0,
  x1: entry.x1,
  y0: entry.y0,
  y1: entry.y1,
});
